import styled from 'styled-components/macro';

export const ButtonWrapper = styled.div`
  display: flex;
  gap: 1rem;

  width: 100%;
  justify-content: space-between;

  margin-top: ${({ theme }) => theme.spacing.two_2};
  padding-right: ${({ theme }) => theme.spacing.zero_3};
`;
